<template>
  <div class="container box">
    <div v-for="setting in settings" :key="setting.setting_id">
      <div class="content" v-if="setting.setting_type == 'percentage'">
        <div class="headerGrid">
          <div class="heading">
            {{ setting.setting_name | title }}
            <b-tooltip class="text" :label="setting.setting_description" position="is-right" multilined>
              <b-icon icon="help"></b-icon>
            </b-tooltip>
          </div>
          <div>
            <b-switch v-model="setting.setting_enabled" true-value="1" false-value="0"></b-switch>
          </div>
        </div>
        <div class="sliderGrid">
          <b-slider
            size="is-medium"
            v-model="setting.setting_threshold"
            :custom-formatter="(val) => val + '%'"
            :disabled="setting.setting_enabled == 0 || setting.setting_enabled == 'false'"
          ></b-slider>
          <div class="center">{{ setting.setting_threshold }}%</div>
        </div>
      </div>
      <div class="content" v-else>
        <div class="headerGrid">
          <div class="heading">
            {{ setting.setting_name | title }}
            <b-tooltip :label="setting.setting_description" position="is-right" multilined>
              <b-icon icon="help"></b-icon>
            </b-tooltip>
          </div>
          <div>
            <b-switch v-model="setting.setting_enabled" true-value="1" false-value="0"></b-switch>
          </div>
        </div>
        <div class="sliderGrid">
          <b-slider size="is-medium" :disabled="setting.setting_enabled == 0 || setting.setting_enabled == 'false'" v-model="setting.setting_threshold"></b-slider>
          <div class="center">{{ setting.setting_threshold }}</div>
        </div>
      </div>
    </div>
    <b-button type="is-success" :loading="loading" @click="UpdateSettings()">Update Settings</b-button>
  </div>
</template>

<style scoped>
.content {
  display: grid;
  border-bottom: 1px solid #8080803b;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.sliderGrid {
  display: grid;
  grid-template-columns: 9fr 1fr;
  gap: 10px;
}
.headerGrid {
  display: grid;
  grid-template-columns: 9fr 1fr;
  gap: 10px;
}
.heading {
  text-transform: unset;
  font-weight: bold;
  font-size: 16px;
}
.center {
  padding-left: 10px;
  height: 40px;
  padding-top: 10px;
  color: grey;
}
</style>

<script>
const axios = require("axios");
export default {
  components: {},
  data: function () {
    return {
      newApiUrl: "https://api.jeak.co.uk",
      apiData: [],
      settings: [],
      loading: false,
    };
  },
  methods: {
    GetSettings: async function () {
      this.loading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios.get(`${this.newApiUrl}/anomalies`, config).then((response) => {
        this.settings = response.data;
        let tmp = JSON.parse(JSON.stringify(response.data));
        this.apiData = tmp;
        this.loading = false;
      });
    },
    UpdateSettings: async function () {
      this.loading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };

      let promiseQueue = [];

      this.settings.forEach((setting) => {
        promiseQueue.push(axios.put(`${this.newApiUrl}/anomalies/${setting.setting_id}`, setting, config));
      });
      Promise.all(promiseQueue).then((values) => {
        this.$buefy.toast.open({
          message: "Anomaly Settings Updated",
          type: "is-success",
        });
        this.GetSettings();
      });
    },
  },
  filters: {
    title: function (value) {
      let finalTitle = "";
      let words = value.split("_");
      words.forEach((word) => {
        finalTitle.length > 0 ? (finalTitle += ` ${word[0].toUpperCase() + word.substring(1)}`) : (finalTitle += `${word[0].toUpperCase() + word.substring(1)}`);
      });

      return finalTitle;
    },
  },
  mounted() {
    this.GetSettings();
  },
};
</script>
